var React = require('react');

function H1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"H1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"49.32 1.13 47.98 29.86 29.15 28.85 21.04 48.59 47.23 49.92 45.89 81.09 68.94 82.08 72.37 2.12 49.32 1.13","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":1},React.createElement("rect",{"x":"4.66","y":"1.08","width":"23.07","height":"80.03","transform":"translate(4.98 -1.63) rotate(6.8)","fill":"#e5c83d"}))])]);
}

H1.defaultProps = {"viewBox":"0 0 72.37 82.2"};

module.exports = H1;

H1.default = H1;
